export default "/images/963c0dc2f1a3e2a84b28a37c5370b195.jpg";